module.exports = __webpack_public_path__ + "img/icon_1R.ca0f5334.svg";